import { useEffect, useState } from 'react';
import { Button } from 'antd';
import { FiArrowRight } from 'react-icons/fi';
import cx from 'classnames';
import useMedia from 'use-media';
import styles from '../../LessonChallengeForm.module.less';

const QuestionSimpleChallenge = ({ nextTrail, title, saveValue, index, name, logo }) => {
  const [displayButton, setDisplayButton] = useState(false);
  const isMobile = useMedia({ maxWidth: 767 });

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDisplayButton(true);
    }, 1000);

    return () => clearTimeout(timeout);
  }, [displayButton]);

  const renderCalculationReportedValues = () => {
    let actualTitle = title.split(' ');
    let isCalculation = "";

    for (let i = 0; i < actualTitle.length; i++) {
      actualTitle[i] = actualTitle[i].replace(/^\s*/, "").replace(/\s*$/, "");

      if (actualTitle[i] === "$SUM_VALUES$") {
        const wordPosition = title.indexOf(actualTitle[i]);
        const removeWordSelectd = title.slice(0, wordPosition)
        isCalculation = actualTitle[i];

        return (
          <h5 className={cx("text-center", styles.titleSimple)}>{`${removeWordSelectd} R$ ${saveValue.toLocaleString('pt-BR', { currency: 'BRL', minimumFractionDigits: 2 })}`}</h5>
        );
      } else if (actualTitle[i] === "$SUM_VALUES_X6$") {
        const wordPosition = title.indexOf(actualTitle[i]);
        const removeWordSelectd = title.slice(0, wordPosition)
        const newSaveValue = saveValue * 6;
        isCalculation = actualTitle[i];

        return (
          <h5 className={cx("text-center", styles.titleSimple)}>{`${removeWordSelectd} R$ ${newSaveValue.toLocaleString('pt-BR', { currency: 'BRL', minimumFractionDigits: 2 })}`}</h5>
        );
      } else if (actualTitle[i] === "$SUM_VALUES_X12$") {
        const wordPosition = title.indexOf(actualTitle[i]);
        const removeWordSelectd = title.slice(0, wordPosition)
        const newSaveValue = saveValue * 12;
        isCalculation = actualTitle[i];

        return (
          <h5 className={cx("text-center", styles.titleSimple)}>{`${removeWordSelectd} R$ ${newSaveValue.toLocaleString('pt-BR', { currency: 'BRL', minimumFractionDigits: 2 })}`}</h5>
        );
      };
    };

    if (isCalculation !== "$SUM_VALUES$" && isCalculation !== "$SUM_VALUES_X6$" && isCalculation !== "$SUM_VALUES_X12$") {
      return (
        <h5 className={cx("text-center", styles.titleSimple)}>{title}</h5>
      );
    };
  };

  return (
    <div key={index}>
      {isMobile ? (
        <div className="container">
          <div className="content">
            <div className="flex flex-column justify-center item-center">
              {/* <div className={styles.bgQuestion}>
                <div className="flex flex-row item-center p-16">
                  <img src={logo} alt="logo-question" className="i-32" />
                  <span className="f18 b mine-shaft ml-16">{name}</span>
                </div>
              </div> */}
              {renderCalculationReportedValues()}
              {displayButton && (
                <>
                  <hr className="divider-internal mb-16" />
                  <Button
                    type="primary"
                    className={cx("flex justify-center item-center mb-24", styles.btnContinue)}
                    onClick={nextTrail}
                  >
                    Continuar
                    <FiArrowRight className={cx("ml-14", styles.iconContinue)} />
                  </Button>
                </>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div className="flex flex-column justify-center item-center">
          <div className={styles.bgQuestion}>
            <div className="flex flex-row item-center p-16">
              <img src={logo} alt="logo-question" className="i-32" />
              <span className="f18 b mine-shaft ml-16">{name}</span>
            </div>
          </div>
          {renderCalculationReportedValues()}
          {displayButton && (
            <>
              <hr className="divider-internal mb-16" />
              <Button
                type="primary"
                className={cx("flex justify-center item-center mb-16", styles.btnContinue)}
                onClick={nextTrail}
              >
                Continuar
                <FiArrowRight className={cx("ml-14", styles.iconContinue)} />
              </Button>
            </>
          )}
        </div>
      )}
    </div >
  );
};

export default QuestionSimpleChallenge;